export const METHODS = [
// @ts-expect-error checking for prototype
Object.prototype.toJSON,
// @ts-expect-error checking for prototype
Array.prototype.toJSON,
// @ts-expect-error checking for prototype
String.prototype.toJSON];